import type {
  CompanyDetailResponse,
  GetRequestedCompanyResponse,
} from "../../../domain/types/admin";
import {CompanyDetailResponseSchema} from "../../../domain/types/admin";
import { GetRequestedCompanyResponseSchema } from "../../../domain/types/admin";
import type { PageableRequest } from "../../../domain/types/shared";
import type { AdminRepository } from "../../../domain/repositories/admin/admin-repository";
import { adminApiService } from "../../api/admin/admin-api-service";

export class AdminRepositoryImpl implements AdminRepository {
  async cancelRequestedCompany(companyAdminId: number): Promise<boolean> {
    const response =
      await adminApiService.cancelRequestedCompany(companyAdminId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "요청된 업체 거절 실패.");
  }

  async approveCompany(companyAdminId: number): Promise<boolean> {
    const response = await adminApiService.approveCompany(companyAdminId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "요청된 업체 승인 실패.");
  }

  async getCompanyInfo(companyId: number): Promise<CompanyDetailResponse> {
    const response = await adminApiService.getCompanyInfo(companyId);

    if (response.data) {
      return CompanyDetailResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "업체 정보 불러오기 실패.");
  }

  async getRequestedCompany(
    pageable: PageableRequest,
  ): Promise<GetRequestedCompanyResponse> {
    const response = await adminApiService.getRequestedCompany(pageable);

    if (response.data) {
      return GetRequestedCompanyResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "신청중인 업체들 불러오기 실패.");
  }
}
